module.exports = __webpack_public_path__ + "img/13.e8710d47.svg";